namespace TabAurous {
    export interface ProductRequest extends Serenity.ListRequest {
        ProductId?: number;
        DesignId?: number;
        ProductCode?: string;
        SKU?: string;
        DesignCode?: string;
        ProductCodes?: string[];
        DesignCodes?: string[];
        AttributeId?: number;
        LedgerId?: number;
        POSCustomerId?: number;
        ProductTypeId?: number;
        ProductTypeIds?: number[];
        ItemTypeId?: number;
        CategoryId?: number;
        KaratId?: number;
        MetalColorId?: number;
        ItemTypeIds?: number[];
        Line_No?: number;
        LineNos?: number[];
        ProductIds?: number[];
        AttributeIds?: number[];
        AttributeTypeId?: number;
        AttributeTypeIds?: number[];
        VoucherTypeId?: number;
        TransId?: number;
        LotNo?: string;
        BagNo?: string;
        DepartmentId?: number;
        DepartmentIds?: number[];
        IsNew?: boolean;
        HasBom?: boolean;
        ForExchange?: boolean;
        IsFeatured?: boolean;
        IsEnquiry?: boolean;
        IsCustomerItem?: boolean;
        EnquiryType?: string;
        ParentDesign?: string;
        PartyIds?: number[];
        VoucherNo?: string;
        VoucherNos?: string[];
        RefNo?: string;
        Iteration?: string;
        ShapeId?: number;
        ShapeIds?: number[];
        StoneSizeId?: number;
        SieveId?: number;
        PartyId?: number;
        CompanyId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        RefTransIds?: number[];
        FromWeight?: number;
        ToWeight?: number;
        FromRate?: number;
        ToRate?: number;
        Products?: TabAurous.Common.CommonProduct[];
        PrintSpecSheet?: boolean;
        CategoryNames?: string[];
        SubCategoryNames?: string[];
        Code?: number;
    }
}
